/* eslint-disable no-alert */

/** The page's one error surface: a browser alert with the raw error. */
export const alertError = (err) => alert(`Terjadi kesalahan system ${err}`);

/** First day of the current month, local time. */
export const monthStart = () => {
  const now = new Date();
  return new Date(now.getFullYear(), now.getMonth(), 1);
};

/** "Rp 1,234,567"; `fallback` is what follows "Rp " when there is no number. */
export const formatRp = (amount, fallback = '') =>
  `Rp ${amount ? amount.toLocaleString() : fallback}`;

/**
 * Parses a typed price like "1,234" into { display: '1,234', value: 1234 }.
 * Empty input is { display: '0', value: 0 }.
 */
export const parsePrice = (text) => {
  const digits = text.split(',').join('');
  if (digits === '') return { display: '0', value: 0 };
  const value = parseInt(digits, 10);
  return { display: value.toLocaleString('en-US'), value };
};
